//time-adjustment-logs?page=1&limit=10&sortBy=createdAt&order=desc&company=Sparkle+Star+International+-+Inhouse
export function getTimeAdjustmentLogs() {
    return {
        "success": true,
        "data": {
            "list": [
                {
                    "_id": "683037682bf6c2246269db59",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:52:56 PM.",
                    "createdAt": "2025-05-23T08:52:56.794Z",
                    "updatedAt": "2025-05-23T08:52:56.794Z",
                    "__v": 0
                },
                {
                    "_id": "6830374c2bf6c2246269db4e",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:52:28 PM.",
                    "createdAt": "2025-05-23T08:52:28.176Z",
                    "updatedAt": "2025-05-23T08:52:28.176Z",
                    "__v": 0
                },
                {
                    "_id": "6830369186bd50545acb16ee",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:49:21 PM.",
                    "createdAt": "2025-05-23T08:49:21.396Z",
                    "updatedAt": "2025-05-23T08:49:21.396Z",
                    "__v": 0
                },
                {
                    "_id": "683036213c5b4f525a220a17",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:47:29 PM.",
                    "createdAt": "2025-05-23T08:47:29.263Z",
                    "updatedAt": "2025-05-23T08:47:29.263Z",
                    "__v": 0
                },
                {
                    "_id": "683035a62418cf52f203e5a3",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:45:26 PM.",
                    "createdAt": "2025-05-23T08:45:26.935Z",
                    "updatedAt": "2025-05-23T08:45:26.935Z",
                    "__v": 0
                },
                {
                    "_id": "6830354d3f00d62dca0094f9",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:43:57 PM.",
                    "createdAt": "2025-05-23T08:43:57.470Z",
                    "updatedAt": "2025-05-23T08:43:57.470Z",
                    "__v": 0
                },
                {
                    "_id": "683034ab8b191b3ca2951909",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:41:15 PM.",
                    "createdAt": "2025-05-23T08:41:15.407Z",
                    "updatedAt": "2025-05-23T08:41:15.407Z",
                    "__v": 0
                },
                {
                    "_id": "6830343f8b191b3ca29518fd",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:39:27 PM.",
                    "createdAt": "2025-05-23T08:39:27.420Z",
                    "updatedAt": "2025-05-23T08:39:27.420Z",
                    "__v": 0
                },
                {
                    "_id": "6830341f8b191b3ca29518f2",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:38:55 PM.",
                    "createdAt": "2025-05-23T08:38:55.247Z",
                    "updatedAt": "2025-05-23T08:38:55.247Z",
                    "__v": 0
                },
                {
                    "_id": "683032f38b191b3ca29518e7",
                    "uid": "64f15182dbd477002ddc95bf",
                    "email": "sparklestarinternationaladm@gmail.com",
                    "name": "Sparkle Star",
                    "processid": "682fb88ebea0fe0073904cb8",
                    "description": "Sparkle Star with uid 64f15182dbd477002ddc95bf updated record with process id 682fb88ebea0fe0073904cb8 dated 5/23/2025, 4:33:55 PM.",
                    "createdAt": "2025-05-23T08:33:55.941Z",
                    "updatedAt": "2025-05-23T08:33:55.941Z",
                    "__v": 0
                }
            ],
            "total": 10
        },
        "meta": {
            "total": 10,
            "page": 1,
            "limit": 10
        }
    }
}